'use es6';

import { Record } from 'immutable'; // Stolen from Gus's ProjectsUI

export default ((spec, defaults) => {
  const obj = typeof spec === 'function' ? spec() : spec;
  const RecordType = Record(obj);
  const emptyRecord = new RecordType();

  RecordType.create = newObj => {
    // Force IDs to strings
    if (newObj && newObj.id) {
      newObj.id = `${newObj.id}`;
    }

    if (newObj instanceof RecordType) {
      return new RecordType(newObj.toMap().merge(defaults(newObj)));
    } else {
      return emptyRecord.merge(Object.assign({}, defaults ? defaults(newObj) : {}, {}, newObj));
    }
  };

  return RecordType;
});